(function (ws) {
    'use strict';
    ws.views.licenseDownloadHistory = ws.views.simpleTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'licence_activity',
        GTM_EVENT_ACTION: 'search_order',

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'change #tbl-simple-orderby': 'searchFilter',
            'click .tbl-magnifying': 'triggerSearch',
            'click .checkAvailabilityOfOrder': 'checkOrderInHybris'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#order-table');
            this.searchUrl = globals.path.api.westcon.licenceDownloadHistoryFetch;
            this.checkOrder = globals.path.api.westcon.checkOrder;
            this.rowTemplate = this.$('#orderlisting-table-row');
            this.overrideFilterRequest = true;
            this.$searchInput = this.$('.tbl-simple-searchInput');
            this.$selectAllCheckbox = this.$('.order-export-checkbox-selectAll');

            this.controlColumn = 0;

            this.showVRFColumns = this.$('#showVRFColumns').val();
            this.enableOrdersExport = this.$('#enableOrdersExport').val();
            this.multiViewEnabled = this.$('#multiViewEnabled').val();

            ws.views.simpleTable.prototype.initialize.call(this);

            //Making the select dropdowns without scroll and without search textbox
            $('.tbl-simple-filters select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table'
            });

            this.licencePerPageValue = this.$('.licence-download-perpage');

            this.searchFilter();

        },

        /**
         * Search
         * @param {Object} e
         */
        search: function (e) {
            if (e.which === 13) {
                this.eventAgg.trigger('resetSortColumns');
                ws.views.simpleTable.prototype.search.call(this, e);
            }
        },

        /**
         * Call Search Filter API
         * Overriding from the parent view
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.clear();
            this.model.set(request);
            this.unsetParams();
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();
            this.enableDelaySpinner();
            $('.invalid-order').hide();

            this.model.save().done(function (data) {
                this.$tableSpinner.hide();
                this.disabledDelaySpinner();

                if (data.totalResultCount > 0) {
                    data.paginationData = {};
                    data.paginationData.currentPage = data.currentPage;
                    data.paginationData.numberOfPages = Math.ceil(data.totalResultCount / parseInt(this.licencePerPageValue.val()));
                    data.paginationData.pageSize = parseInt(this.licencePerPageValue.val());
                    data.paginationData.totalNumberOfResults = data.totalResultCount;
                }

                this.renderRows(data.entitlement);

                this.calculateShowing(data.paginationData);
                this.calculatePagination(data.paginationData);
                this.$pagination.addClass('search');
                this.$clearFilterButton.toggle(this.showClearFilterButton);
                if (this.showClearFilterButton) {
                    this.$('.message-link').hide();
                }

                this.toggleApplySearchBtn(true);
                if (this.enableOrdersExport == 'true') {
                    this.$selectAllCheckbox.attr('checked', false);
                }

                dataLayerAA.search = {};
                dataLayerAA.search.type = 'license downloads';

                //need to check if search field or query contains special characters
                dataLayerAA.search.field = request.searchProperty.toString();
                dataLayerAA.search.query = request.searchText.toString();
                dataLayerAA.event = {};
                dataLayerAA.event.category = 'license_activity';
                dataLayerAA.event.action = 'search license downloads';
                dataLayerAA.event.label = request.searchText.toString();
                _satellite.track('event:search');
                dataLayer.push({event: 'new_gtm_event'});
            }.bind(this)).fail(function () {
                this.tableGenericError();
                this.disabledDelaySpinner();
            }.bind(this));
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            if (this.enableOrdersExport == 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.enableDownlodButton();
            }

            var options;
            var _this = this;
            _.each(result, function (row) {
                row.showVRFColumns = _this.showVRFColumns;
                row.enableOrdersExport = _this.enableOrdersExport;
                row.multiViewEnabled = _this.multiViewEnabled;
                if (row.status == null) {
                    row.status = '';
                }

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            this.eventAgg.trigger('resetSortColumns');
            const e = $.Event('keypress', {which: 13});
            this.$searchInput.trigger(e);
        },

        /**
         * Override filter request object
         * @param {Object} request
         */
        customFilterRequest: function (request) {
            return _.extend({}, request, {
                dateFormat: $('#dateFormat').val()
            });
        },

        /**
         * Update Pikaday end date
         */
        pikadayUpdateEndDate: function (startPicker, endPicker, endDate) {
            if (endDate) {
                startPicker.pikaday('setMaxDate', endDate);
            }
        },

        /**
         * simple table override to get table data
         */
        getClearFilterTableData: function () {

            //reset sort columns. avoiding event trigger
            this.sortCode = null;
            this.sortColumn = null;
            this.$sortableColumns.removeClass('asc').removeClass('desc');

            this.searchFilter();
        },

        /**
         * need not set history. we need to optimize setting history since there are multiple states pushed for single url change
         */
        setHistory: function () {

        },

        disableFutureDate: true
    });
})(westcon);
